import { SettingOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import ".././stylestabs.scss";
import { Dashboard } from "../../../../components/ExportImgFigma";
import "../../styles.scss";
import { mixGetV2 } from '../../../../services/mixin';
import MegaTable from "../../../../components/MagaTableV2";
import { useSelector } from 'react-redux';
import { selectorInfoUser } from '../../../../store/slices/infoUserSlice';

const MaintenanceHistory = ({ stData = {} as any, stChange = (data: any, type: any) => { } }) => {
  const user = useSelector(selectorInfoUser);

  const STATUS_FIELDS = [
    'vehicle_status', 'group_staus_name',
    'status_name',
  ];
  const STATUS_HEADER_KEYWORDS = ['Trạng thái KH', 'Nhận định KH'];

  const getStatusBadgeClass = (value: any) => {
    if (value === null || value === undefined || value === '') return '';
    const v = String(value).toLowerCase().trim();
    if (v === 'contact') return 'status-contact';
    if (v === 'cool' || v === 'prospect') return 'status-cool';
    if (v === 'traffic' || v === 'warm' || v === 'appointment' || v === 'test drive') return 'status-traffic';
    if (v === 'hot' || v === 'sale offer') return 'status-hot';
    if (v === 'booking' || v === 'sale contract') return 'status-booking';
    if (v === 'fail' || v === 'fail contract') return 'status-fail';
    return 'status-default';
  };
  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.customer_care_vehicle_histories?.list.map((col: any) => {
      const isStatus =
        STATUS_FIELDS.includes(col.field) ||
        STATUS_HEADER_KEYWORDS.some((kw: string) => col.headerName?.includes(kw));
      temp.push({
        headerName: col.headerName,
        field: col.field,
        tooltipField: col.field,
        ...(isStatus && {
          cellRenderer: (params: any) => {
            const val = params.value;
            if (!val || val === 'Không xác định') return <span style={{ color: '#181d1f' }}>Không xác định</span>;
            return (
              <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                <span className={`status-badge ${getStatusBadgeClass(val)}`}>{val}</span>
              </div>
            );
          },
        }),
      })
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheVehicleContactHistory',
    col: [
      ...tableColumns(stData.sourceColumnWarehouse),
      // { field: 'dms_doc_id', headerName: 'Id tiếp xúc' },
      // { field: 'doc_date_ct', headerName: 'Ngày tiếp xúc' },
      // { field: 'customer_interactions_approved_date', headerName: 'Ngày phê duyệt' },
      // { field: 'customer_interactions_note', headerName: 'Nội dung tiếp xúc' },
      // { field: 'status_name', headerName: 'Trạng thái' },
      // { field: 'status', headerName: 'Mã trạng thái' },
      // { field: 'group_status_code', headerName: 'Mã nhận định khách hàng' },
      // { field: 'group_staus_name', headerName: 'Nhận định khách hàng' },
      // { field: 'customer_interactions_box_code', headerName: 'Thùng' },
      // { field: 'customer_interactions_chassis_no', headerName: 'Số khung (VIN)' },
      // { field: 'customer_interactions_employee_code', headerName: 'Mã nhân viên' },
      // { field: 'customer_interactions_employee_name', headerName: 'Tên nhân viên' },
      // { field: 'group_employee_code', headerName: 'Mã nhóm nhân viên' },
      // { field: 'group_vehicle_code', headerName: 'Mã nhóm xe' },
      // { field: 'branch_name', headerName: 'Đơn vị tiếp xúc' },
      // { field: 'route_name', headerName: 'Điểm bán hàng tiếp xúc' },
    ],
    listData: [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
    height: '400px',
  });

  const [loading, setLoading] = useState(false);
  const [detailData, setDetailData] = useState<any>({ list: [], latest_interaction_date: '', total_interactions: 0, latest_group_status_name: '' });
  const getDetail = async (id: any) => {
    setLoading(true);
    const res = await mixGetV2(`/api/v1/be/customer/vehicle_interaction_history?customer_id=${stData.cus_id}&customer_code_dms=${id}&admin_id=${user.id}`);
    if (res.data) {
      const interactions = Array.isArray(res.data) ? res.data : (res.data.interactions || res.data.list || []);
      const latestGroupStatus = interactions.length > 0 ? (interactions[0].group_staus_name || interactions[0].status_name || '') : '';
      const latestDate = res.data.latest_interaction_date || (interactions.length > 0 ? (interactions[0].doc_date_ct || '') : '');
      const totalInteractions = res.data.total_interactions ?? interactions.length;
      setDetailData({
        list: interactions,
        latest_interaction_date: latestDate,
        total_interactions: totalInteractions,
        latest_group_status_name: latestGroupStatus,
      });
      stChange(interactions, 'vehicle_interaction_history');
      setLoading(false);
    }
  }
  useEffect(() => {
    if (stData.xesohuu_show && stData.xesohuu_show.customer_code_dms_cus) {
      getDetail(stData.xesohuu_show.customer_code_dms_cus);
    }
  }, [stData.xesohuu_show]);

  return (
    <>
      <div className="setting-tb-has-tab">
        <div className='settingCol'>
          <div className='ctr-col-setting' onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}>
            <SettingOutlined />
          </div>
        </div>
      </div>
      <div className="custom-page-css w-full flex gap-3 mb-3">
        <div className="custom-page-css flex flex-1 flex-column rounded border" style={{ flex: '1 1 50%', minWidth: 0 }}>
          <div className="custom-page-css w-full flex items-center gap-4 p-3 border-b">
            <div className="custom-page-css flex items-center justify-center p-1 bg-E6F7FF rounded-full w-1/3">
              <img
                src={Dashboard}
                alt=""
                style={{ height: 16, width: 16, objectFit: "contain" }}
              />
            </div>
            <span className="custom-page-css text-xl font-light text-475467">
              Tổng quan
            </span>
          </div>
          <div className="custom-page-css flex py-2">
            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 border-r">
              <span className="custom-page-css text-2xl font-light font-medium px-1 text-344054">
                {detailData.total_interactions}
              </span>
              <span className="custom-page-css text-xl font-light text-475467">
                Số lần tiếp xúc
              </span>
            </div>
            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 border-r">
              <span className="custom-page-css text-2xl font-light font-medium px-1 text-344054">
                {detailData.latest_interaction_date || "Không xác định"}
              </span>
              <span className="custom-page-css text-xl font-light text-475467">
                Ngày tiếp xúc gần nhất
              </span>
            </div>
            <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1">
              {detailData.latest_group_status_name ? (
                <span className={`status-badge ${getStatusBadgeClass(detailData.latest_group_status_name)}`}>
                  {detailData.latest_group_status_name}
                </span>
              ) : (
                <span className="custom-page-css text-2xl font-light font-medium px-1 text-344054">
                  Không xác định
                </span>
              )}
              <span className="custom-page-css text-xl font-light text-475467">
                Trạng thái KH gần nhất
              </span>
            </div>
          </div>
        </div>
      </div>
      <MegaTable
        stData={{ ...megaTableData, listData: detailData.list, loading: loading }}
        stChange={(data) => {
          setMegaTableData((prev: any) => ({ ...prev, ...data }));
        }}
      />
    </>
  );
};
export default MaintenanceHistory;
